export default "__VITE_ASSET__DL8ELZJ$__"